var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.648 3.023 11.784 8.76a1.947 1.947 0 0 1-1.852 1.346H3.899c-1.887 0-2.671 2.414-1.145 3.523l4.88 3.546c.683.496.969 1.375.708 2.177L6.478 25.09c-.583 1.794 1.47 3.286 2.997 2.177l4.88-3.546a1.947 1.947 0 0 1 2.29 0l4.88 3.546c1.527 1.109 3.58-.383 2.997-2.177l-1.864-5.738a1.947 1.947 0 0 1 .707-2.177l4.88-3.546c1.527-1.11.742-3.523-1.144-3.523h-6.033a1.947 1.947 0 0 1-1.852-1.346l-1.864-5.737c-.583-1.794-3.121-1.794-3.704 0z",
    fill: "#FFE14B",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a8fd8bc9959e7487c5e1560791b3c825.svg";
export { ForwardRef as ReactComponent };